var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FeatureTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IMoH7gpu5un5Dx2vID39Ra",
    x1: 9.858,
    x2: 38.142,
    y1: 9.858,
    y2: 38.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9dffce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50d18d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IMoH7gpu5un5Dx2vID39Ra)",
    d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IMoH7gpu5un5Dx2vID39Rb",
    x1: 13,
    x2: 36,
    y1: 24.793,
    y2: 24.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#135d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#125933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11522f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IMoH7gpu5un5Dx2vID39Rb)",
    d: "M21.293,32.707l-8-8c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414 c0.391-0.391,1.024-0.391,1.414,0L22,27.758l10.879-10.879c0.391-0.391,1.024-0.391,1.414,0l1.414,1.414 c0.391,0.391,0.391,1.024,0,1.414l-13,13C22.317,33.098,21.683,33.098,21.293,32.707z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FeatureTick);
export default __webpack_public_path__ + "static/media/icons8-feature-tick.7c52fbf99964cf74475b5f8d8270e61a.svg";
export { ForwardRef as ReactComponent };